import React, { useState, ChangeEventHandler, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, useHistory, useParams } from "react-router-dom";
import useLocalStorage from 'use-local-storage'
import moment from 'moment';
import {
    Layout,
    Row,
    Col,
    Button,
    Menu,
    Dropdown
} from 'antd';

import { userRoutes } from "../../routers/routes";

// Other Layout related Component
import Sidebar from "./Sidebar";
import HeaderPage from "./Header";
import FooterPage from "../Footer/Footer";
import Trending from "../Trending";
import '../../assets/css/dashboard.css';
import Footer_banner from  '../../assets/images/footer-banner.png';

const { Header, Content, Sider } = Layout;


const DashboardLayout = ({ children, disconnect, ...rest }) => {

    let current_time = moment().format("HH");
    
    const [isMenuOpened, checkIsMenuOpened] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const defaultDark = window.matchMedia('(prefers-color-scheme: light)').matches;
    const [theme, setTheme] = useLocalStorage('theme', defaultDark ? 'light' : 'dark');

    const checkModeTheme = () => {
        if( current_time > 6  && current_time < 18 ){
            setTheme('light');
        } else{
            setTheme('dark');
        }
    }

    const openMenu = () => {
        setCollapsed(!collapsed);
    }

    const switchTheme = () => {
        const newTheme = theme === 'light' ? 'dark' : 'light';
        setTheme(newTheme);
    }

    useEffect(() => {
        checkModeTheme();
    }, [current_time]);

    

    return (
        <React.Fragment>
            <Layout id="layout-wrapper" data-theme={theme}>
                <HeaderPage
                    collapsed={collapsed}
                    openLeftMenuCallBack={openMenu}
                    disconnect={() => disconnect()}
                    switchThemeCallBack={switchTheme}
                    defaultTheme={theme}
                />
                <Layout className="layout-full-height">
                    <Sidebar collapsed={collapsed} />
                    <Layout
                        className={!collapsed && 'layout-not-full'}
                        style={{
                            padding: '0 24px 24px',
                        }}
                    >
                        <Trending />
                        <Content
                            className="site-layout-background"
                            style={{
                                padding: 24,
                                margin: 0,
                                minHeight: 280,
                            }}
                        >
                            {
                                userRoutes.map((route, idx) => (
                                    <DashboardLayoutRoute
                                        path={route.path}
                                        component={route.component}
                                        key={idx}
                                        // isAuthProtected={true}
                                    />
                                ))
                            }
                        </Content>
                        <Row justify="center" className="row-margin-normal">
                            <Col span={16} xs={24}>
                                <div className="text-white font-small text-center">Disclaimer: The information provided shall not in any way constitute a recommendation as to whether you should invest in any product discussed. We accept no liability for any loss occasioned to any person acting or refraining from action as a result of any material provided or published.</div>
                            </Col>
                        </Row>
                        <FooterPage defaultTheme={theme} />
                    </Layout>
                </Layout>
                {/* <div className="footer-banner">
                    <img src={Footer_banner} alt="" />
                </div> */}
                
            </Layout>

        </React.Fragment>
    )
}

const DashboardLayoutRoute = ({ component: Component, path }) => {
    return (
        // <Route
        //     {...rest}
        //     render={(props) => (
        //         <DashboardLayout disconnect={() => disconnect()}>
        //             <Component {...props} />
        //         </DashboardLayout>
        //     )}
        // />
        <Route
            exact
            path={path}
            component={Component}
        />
    );
};


export default DashboardLayout;
